module.exports = __webpack_public_path__ + "img/simulation.8ff352df.png";